import React from "react";
import { useTheme } from "styled-components";

const Spaces = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.236 12.094a.563.563 0 0 1-.205.767l-6.75 3.937a.56.56 0 0 1-.566 0l-6.75-3.937a.562.562 0 0 1 .566-.972L9 15.661l6.469-3.772a.56.56 0 0 1 .767.205m-.767-3.58L9 12.286 2.531 8.514a.563.563 0 0 0-.562.972l6.75 3.937a.56.56 0 0 0 .566 0l6.75-3.937a.563.563 0 1 0-.566-.972M1.688 5.624a.56.56 0 0 1 .28-.485l6.75-3.937a.56.56 0 0 1 .567 0l6.75 3.937a.563.563 0 0 1 0 .972l-6.75 3.937a.56.56 0 0 1-.566 0l-6.75-3.937a.56.56 0 0 1-.282-.486m1.679 0L9 8.912l5.633-3.286L9 2.339z"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default Spaces;
